"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UPDATE_ROLE_PERMISSIONS = exports.ZodWearable = exports.ZodWearableParts = exports.InitialWearables = exports.RequiredWearables = exports.WearableColors = exports.DEFAULT_HAIR_COLORS = exports.DEFAULT_WEARABLE_COLORS = exports.WearableLayerOrderMap = exports.WearableLayerLegacy = exports.WearableSubType = exports.WearableType = void 0;
const zod = __importStar(require("zod"));
const Player_1 = require("@gathertown/gather-game-common/dist/src/public/Player");
var WearableType;
(function (WearableType) {
    WearableType["Skin"] = "skin";
    WearableType["Hair"] = "hair";
    WearableType["FacialHair"] = "facial_hair";
    WearableType["Top"] = "top";
    WearableType["Bottom"] = "bottom";
    WearableType["Shoes"] = "shoes";
    WearableType["Hat"] = "hat";
    WearableType["Glasses"] = "glasses";
    WearableType["Other"] = "other";
    WearableType["Costume"] = "costume";
    WearableType["Mobility"] = "mobility";
    WearableType["Jacket"] = "jacket";
})(WearableType || (exports.WearableType = WearableType = {}));
var WearableSubType;
(function (WearableSubType) {
    WearableSubType["Seasonal"] = "seasonal";
    WearableSubType["Internal"] = "internal";
    WearableSubType["Experimental"] = "experimental";
})(WearableSubType || (exports.WearableSubType = WearableSubType = {}));
var WearableLayerLegacy;
(function (WearableLayerLegacy) {
    WearableLayerLegacy["Mobility_Back"] = "mobility back";
    WearableLayerLegacy["Other_Back"] = "other back";
    WearableLayerLegacy["Hat_Back"] = "hat back";
    WearableLayerLegacy["Hair_Back"] = "hair back";
    WearableLayerLegacy["Jacket_Back"] = "jacket back";
    WearableLayerLegacy["Skin_Front"] = "skin front";
    WearableLayerLegacy["Bottom_Front"] = "bottom front";
    WearableLayerLegacy["Shoes_Front"] = "shoes front";
    WearableLayerLegacy["Top_Front"] = "top front";
    WearableLayerLegacy["Jacket_Front"] = "jacket front";
    WearableLayerLegacy["Other_Middle"] = "other middle";
    WearableLayerLegacy["Glasses_Front"] = "glasses front";
    WearableLayerLegacy["Facial_Hair_Front"] = "facial_hair front";
    WearableLayerLegacy["Hair_Front"] = "hair front";
    WearableLayerLegacy["Hat_Front"] = "hat front";
    WearableLayerLegacy["Other_Front"] = "other front";
    WearableLayerLegacy["Mobility_Front"] = "mobility front";
    WearableLayerLegacy["Costume_Front"] = "costume front";
})(WearableLayerLegacy || (exports.WearableLayerLegacy = WearableLayerLegacy = {}));
exports.WearableLayerOrderMap = {
    [WearableLayerLegacy.Mobility_Back]: 0,
    [WearableLayerLegacy.Other_Back]: 10,
    [WearableLayerLegacy.Hat_Back]: 20,
    [WearableLayerLegacy.Hair_Back]: 30,
    [WearableLayerLegacy.Jacket_Back]: 40,
    [WearableLayerLegacy.Skin_Front]: 50,
    [WearableLayerLegacy.Bottom_Front]: 60,
    [WearableLayerLegacy.Shoes_Front]: 70,
    [WearableLayerLegacy.Top_Front]: 80,
    [WearableLayerLegacy.Jacket_Front]: 90,
    [WearableLayerLegacy.Other_Middle]: 100,
    [WearableLayerLegacy.Glasses_Front]: 110,
    [WearableLayerLegacy.Facial_Hair_Front]: 120,
    [WearableLayerLegacy.Hair_Front]: 130,
    [WearableLayerLegacy.Hat_Front]: 140,
    [WearableLayerLegacy.Other_Front]: 150,
    [WearableLayerLegacy.Mobility_Front]: 160,
    [WearableLayerLegacy.Costume_Front]: 170,
};
exports.DEFAULT_WEARABLE_COLORS = {
    red: "#F03827",
    orange: "#FBA055",
    yellow: "#FFCA43",
    olive: "#66783E",
    green: "#349141",
    viridian: "#1D766B",
    blue: "#2DBDFF",
    indigo: "#7284FC",
    purple: "#9869B1",
    magenta: "#E83DC4",
    pink: "#F76898",
    brown: "#C0734F",
    cream: "#E3CAAE",
    white: "#FFFFFF",
    grey: "#9193A6",
    black: "#32343B",
};
exports.DEFAULT_HAIR_COLORS = {
    white: "#D0D0D0",
    black: "#453E50",
    brown: "#674239",
    caramel: "#AB7144",
    "dirty blond": "#9F8553",
    blond: "#F2B55B",
    auburn: "#933A29",
    ginger: "#E4863A",
    pink: "#FF9CA6",
    purple: "#846ECA",
    blue: "#498BC5",
    green: "#8AB36E",
};
exports.WearableColors = {
    [WearableType.Skin]: {
        1: "#fddab5",
        2: "#f9bf95",
        3: "#d8885c",
        4: "#ab633b",
        5: "#75412b",
    },
    [WearableType.Hair]: exports.DEFAULT_HAIR_COLORS,
    [WearableType.FacialHair]: exports.DEFAULT_HAIR_COLORS,
    [WearableType.Hat]: exports.DEFAULT_WEARABLE_COLORS,
    [WearableType.Glasses]: exports.DEFAULT_WEARABLE_COLORS,
    [WearableType.Other]: exports.DEFAULT_WEARABLE_COLORS,
    [WearableType.Top]: exports.DEFAULT_WEARABLE_COLORS,
    [WearableType.Bottom]: exports.DEFAULT_WEARABLE_COLORS,
    [WearableType.Shoes]: exports.DEFAULT_WEARABLE_COLORS,
    [WearableType.Mobility]: exports.DEFAULT_WEARABLE_COLORS,
    [WearableType.Jacket]: exports.DEFAULT_WEARABLE_COLORS,
    [WearableType.Costume]: {},
    [WearableSubType.Seasonal]: {
        ...exports.DEFAULT_WEARABLE_COLORS,
        black: "#454345",
    },
    [WearableSubType.Internal]: {
        ...exports.DEFAULT_WEARABLE_COLORS,
        black: "#454345",
    },
    [WearableSubType.Experimental]: {
        ...exports.DEFAULT_WEARABLE_COLORS,
        black: "#454345",
    },
};
exports.RequiredWearables = new Set([WearableType.Skin]);
exports.InitialWearables = {
    [WearableType.Skin]: { color: "3", name: "typical" },
    [WearableType.Hair]: {},
    [WearableType.FacialHair]: null,
    [WearableType.Top]: { name: "t shirt" },
    [WearableType.Bottom]: { name: "pants" },
    [WearableType.Shoes]: { color: "black", name: "generic" },
    [WearableType.Hat]: null,
    [WearableType.Glasses]: null,
    [WearableType.Other]: null,
    [WearableType.Costume]: null,
    [WearableType.Mobility]: null,
    [WearableType.Jacket]: null,
};
const ZodWearablePart = zod.object({
    spritesheetId: zod.string(),
    spritesheetUrl: zod.string().optional(),
    layerId: zod.nativeEnum(WearableLayerLegacy),
});
exports.ZodWearableParts = zod.array(ZodWearablePart);
exports.ZodWearable = zod.object({
    color: zod.string(),
    name: zod.string(),
    type: zod.nativeEnum(WearableType),
    style: zod.string().nullable().optional(),
    subType: zod.nativeEnum(WearableSubType).nullable().optional(),
    isDefault: zod.boolean(),
    previewUrl: zod.string(),
    parts: exports.ZodWearableParts,
    startDate: zod.string().nullable().optional(),
    endDate: zod.string().nullable().optional(),
});
exports.UPDATE_ROLE_PERMISSIONS = {
    [Player_1.CoreRole.GeneralMember]: [Player_1.CoreRole.GeneralMember, Player_1.CoreRole.Guest],
    [Player_1.CoreRole.Builder]: [Player_1.CoreRole.GeneralMember, Player_1.CoreRole.Guest],
    [Player_1.CoreRole.Mod]: [
        Player_1.CoreRole.Builder,
        Player_1.CoreRole.Mod,
        Player_1.CoreRole.GeneralMember,
        Player_1.CoreRole.Speaker,
        Player_1.CoreRole.Guest,
    ],
    [Player_1.CoreRole.Owner]: [
        Player_1.CoreRole.Owner,
        Player_1.CoreRole.Builder,
        Player_1.CoreRole.Mod,
        Player_1.CoreRole.GeneralMember,
        Player_1.CoreRole.Speaker,
        Player_1.CoreRole.Guest,
    ],
    [Player_1.CoreRole.Speaker]: [],
    [Player_1.CoreRole.Guest]: [],
    [Player_1.CoreRole.RecordingClient]: [],
};
//# sourceMappingURL=users.js.map